module.exports = __webpack_public_path__ + "assets/fe2bd6623681661ff706e61aa63e6b34.png";